import React from 'react';
import { DragAndDrop } from '../Drag-and-drop';
import * as meta from '../../meta-data.json';

export const View = (props: any) => {
	const user = props.items;

	// const projects = ['Ansera', 'Clasera', 'DFR', 'PWB', 'Search Platform'];
	const projects = [
		<div key={'Ansera'} className="w-100" style={{ textAlign: 'center', color: 'red' }}>
			<h2>An</h2>
		</div>,
		<div key={'Clasera'} className="w-100" style={{ textAlign: 'center', color: 'purple' }}>
			<h2>Cls</h2>
		</div>,
		<div key={'DFR'} className="w-100" style={{ textAlign: 'center', color: 'blue' }}>
			<h2>DFR</h2>
		</div>,
		<div key={'PWB'} className="w-100" style={{ textAlign: 'center', color: 'green' }}>
			<h2>PWB</h2>
		</div>,
		<div key={'Search Platform'} className="w-100" style={{ textAlign: 'center' }}>
			<h2>SP</h2>
		</div>,
	];

	return (
		<DragAndDrop
			data-epo={`epo-appSwitcher-${meta.version}`}
			dndTemplate="Custom"
			items={{ highlightedProjects: user.highlightedProjects, allProjects: user.allProjects }}
			children={projects}
		/>
	);
};
